import { useEffect, useState } from "react";
import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import { ReactComponent as IconInfo } from "../Images/icon_info.svg";
import { ReactComponent as IconInfoRed } from "../Images/icon_info_red.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

export const MemberCheckBox = ({ type, handleApply, handleClickX }) => {
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setIsButtonEnabled(checked);
  }, [checked]);
  return (
    <Box>
      <div className="hrz-wrapper center">
        <p
          className="bold-text"
          style={{ fontSize: "24px", marginLeft: "auto", marginRight: "-32px" }}
        >
          구성원&nbsp;{type}
        </p>
        <IconCrossRound
          style={{ marginLeft: "auto", cursor: "pointer" }}
          onClick={handleClickX}
        />
      </div>

      <div
        style={{
          padding: "14px 10px",
          backgroundColor:
            type === "활성화" ? "#DBE8FD" : "rgb(242,92,92, 0.15)",
          borderRadius: "10px",
          marginTop: "20px",
          maxWidth: "380px",
        }}
      >
        <div style={{ display: "flex" }}>
          {type === "활성화" ? <IconInfo fill="#1167ed" /> : <IconInfoRed />}
          <p
            style={{
              fontSize: "14px",
              fontFamily: "notoSans-medium",
              marginLeft: "4px",
            }}
          >
            {type} 전 꼭 확인해주세요!
          </p>
        </div>
        {type === "비활성화" ? (
          <div style={{ marginTop: "10px" }}>
            <p style={{ fontSize: "14px", color: "#555555" }}>
              &nbsp;· 비활성화 된 구성원은 더이상 랭킹마라톤 앱의 기업모드를
              이용할 수 없습니다.
            </p>
            <p style={{ fontSize: "14px", color: "#555555" }}>
              &nbsp;· 다시 기업모드를 이용하기 위해서는 대시보드 내에서 해당
              구성원을 재활성화해야합니다.
            </p>
          </div>
        ) : type === "활성화" ? (
          <div style={{ marginTop: "10px" }}>
            <p style={{ fontSize: "14px", color: "#555555" }}>
              &nbsp;· 구성원을 활성화하면 구성원이 다시 랭킹마라톤 기업모드를
              이용할 수 있습니다.
            </p>
            <p style={{ fontSize: "14px", color: "#555555" }}>
              &nbsp;· 남은 구성원 용량이 없으면 활성화가 불가능합니다.
            </p>
          </div>
        ) : (
          <div style={{ marginTop: "10px" }}>
            <p style={{ fontSize: "14px", color: "#555555" }}>
              &nbsp;· 탈퇴된 구성원은 더이상 랭킹마라톤 앱의 기업모드를 이용할
              수 없습니다.
            </p>
            <p style={{ fontSize: "14px", color: "#555555" }}>
              &nbsp;· 탈퇴된 구성원의 회원 정보가 즉시 삭제됩니다.
            </p>
            <p style={{ fontSize: "14px", color: "#555555" }}>
              &nbsp;· 다시 기업모드를 이용하기 위해서는 기업 이메일을
              재인증해야합니다.
            </p>
          </div>
        )}
      </div>

      <div style={{ display: "flex", marginTop: "20px" }}>
        <input
          type="checkbox"
          id="checkbox"
          style={{ width: "20px", height: "20px", cursor: "pointer" }}
          onChange={(e) => setChecked(e.target.checked)}
        />
        <label
          htmlFor="checkbox"
          className="bold-text"
          style={{ marginLeft: "4px", cursor: "pointer" }}
        >
          주의사항을 숙지하였습니다.
        </label>
      </div>

      <div className="hrz-wrapper" style={{ marginTop: "30px" }}>
        <div
          className="blueBtn-base center"
          style={{
            width: "400px",
            height: "60px",
            borderRadius: "10px",
            fontFamily: "notoSans-medium",
            backgroundColor:
              type === "활성화" && isButtonEnabled
                ? "#1167ed"
                : isButtonEnabled
                ? "#f25c5c"
                : "#b0b0b0",
          }}
          onClick={isButtonEnabled ? handleApply : null}
        >
          {type === "비활성화"
            ? "비활성화 하기"
            : type === "활성화"
            ? "활성화 하기"
            : "탈퇴"}
        </div>
      </div>
    </Box>
  );
};

const MemberCheck = ({ type, handleApply, handleClickX }) => {
  return (
    <LayoutModal
      Modal={
        <MemberCheckBox
          type={type}
          handleApply={handleApply}
          handleClickX={handleClickX}
        />
      }
    />
  );
};

const Box = styled.div`
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

export default MemberCheck;
